var $ = require('jquery');
var slick = require('slick-carousel');


module.exports = (function() {
	var $slider = $('.product__gallery-slider'),
		$preview = $('.product__preview');

	$slider.slick({
		prevArrow: '<button type="button" class="slick-prev"><i class="icon icon-slider-prev-black"></i></button>',
		nextArrow: '<button type="button" class="slick-next"><i class="icon icon-slider-next-black"></i></button>'
	});

	$slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
		$preview.removeClass('product__preview--active').filter('[data-slide-index="'+nextSlide+'"]').addClass('product__preview--active');
	});

	$preview.on('click', function(e) {
		e.preventDefault();
		e.stopPropagation();

		$slider.slick('slickGoTo', this.dataset.slideIndex);
	});

	/* Change size */

	$('body').on('change', '.product__data[data-url-change]', function() {
		var form = this;

		$.ajax({
			'url': form.dataset.urlChange,
			'data': $(form).serialize(),
			'type': 'get',
			'dataType': 'html'
		}).done(function(data) {
			form.outerHTML = data;
			initSizesTable();
		});
	}).on('submit', '.product__data[data-url-change]', function(e) {
		e.preventDefault();
		e.stopPropagation();

		var form = this;

		$.ajax({
			'url': form.action,
			'data': $(form).serialize(),
			'type': form.type,
			'dataType': 'json'
		}).done(function(data) {
			document.querySelector('.header__cart').outerHTML = data.htmlHeaderCart;
			document.querySelector('.topline__item--cart').outerHTML = data.htmlToplineCart;
			form.outerHTML = data.htmlProductData;
		});
	});

	initSizesTable();

	function initSizesTable() {
		$('a[href="#sizes-table"]').fancybox({
			padding: 0,
			tpl: {
				closeBtn: ''
			}
		});
	}
})();
